export default [
  {
    key: 'ANDROID',
    value: 'Android',
    id: 'ANDROID',
    children: [
      {
        key: 'ANDROID_VERSION_1',
        value: 'Android 1.x',
        id: 'ANDROID_VERSION_1'
      },
      {
        key: 'ANDROID_VERSION_2',
        value: 'Android 2.x',
        id: 'ANDROID_VERSION_2'
      },
      {
        key: 'ANDROID_VERSION_3',
        value: 'Android 3.x',
        id: 'ANDROID_VERSION_3'
      },
      {
        key: 'ANDROID_VERSION_4',
        value: 'Android 4.x',
        id: 'ANDROID_VERSION_4'
      },
      {
        key: 'ANDROID_VERSION_5',
        value: 'Android 5.x',
        id: 'ANDROID_VERSION_5'
      },
      {
        key: 'ANDROID_VERSION_6',
        value: 'Android 6.x',
        id: 'ANDROID_VERSION_6'
      },
      {
        key: 'ANDROID_VERSION_7',
        value: 'Android 7.x',
        id: 'ANDROID_VERSION_7'
      },
      {
        key: 'ANDROID_VERSION_8',
        value: 'Android 8.x',
        id: 'ANDROID_VERSION_8'
      },
      {
        key: 'ANDROID_VERSION_9',
        value: 'Android 9.x',
        id: 'ANDROID_VERSION_9'
      },
      {
        key: 'ANDROID_VERSION_10',
        value: 'Android 10.x',
        id: 'ANDROID_VERSION_10'
      },
      {
        key: 'ANDROID_VERSION_11',
        value: 'Android 11.x',
        id: 'ANDROID_VERSION_11'
      },
      {
        key: 'ANDROID_VERSION_12',
        value: 'Android 12.x',
        id: 'ANDROID_VERSION_12'
      },
      {
        key: 'ANDROID_VERSION_13',
        value: 'Android 13.x',
        id: 'ANDROID_VERSION_13'
      },
      {
        key: 'ANDROID_VERSION_14',
        value: 'Android 14.x',
        id: 'ANDROID_VERSION_14'
      },
      {
        key: 'ANDROID_VERSION_15',
        value: 'Android 15.x',
        id: 'ANDROID_VERSION_15'
      }
    ]
  }
]
